import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { pxToRem } from '@pc/shared';

@Component({
  selector: 'pc-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {
  @HostBinding('style.position') @Input() position: 'fixed' | 'static' = 'fixed';
  @Input() minHeaderHeight = 87;

  @HostBinding('style.min-height.rem')
  get minHeight() {
    return pxToRem(this.minHeaderHeight);
  }
}
